import { PasswordFormButtons } from './PasswordFormButtons';
import { useForm } from '../../hooks/useForm';
import { useUser } from '../../contexts/UserContext';
import { PasswordField } from '../PasswordField';
import { PasswordRequirements } from './PasswordRequirements';
import { useEffect, useState } from 'react';
import { Progress } from '../ProgressBar/Progress';

interface Props {
  onClose(): void;
}

export const PasswordFormFields = ({ onClose }: Props) => {
  const [submitted, setSubmitted] = useState(false);
  const user = useUser();
  const { onChange, onSubmit, resetForm, values } = useForm(
    {
      currentPassword: '',
      newPassword: '',
      newConfirm: '',
    },
    () => {
      user.changePassword(
        values.currentPassword,
        values.newPassword,
        values.newConfirm
      );
      setSubmitted(true);
    }
  );

  useEffect(() => {
    if (!user.loading && submitted && !user.error) {
      onClose();
      resetForm();
    }
  }, [user.error, submitted, user.loading]);

  const newPasswordError =
    values.newPassword !== '' && !testPassword(values.newPassword);
  const confirmError =
    (values.newConfirm !== '' &&
      values.newPassword !== '' &&
      values.newConfirm !== values.newPassword) ||
    (values.newPassword.length !== values.newConfirm.length &&
      values.newConfirm.length > 0);

  function testPassword(newPassword: string): boolean {
    return /^(?=.*[A-Za-z])(?=.*\d)(?=.*[$!@#$%^&*()_\-+=[{\]};:<>|./?])[A-Za-z\d$!@#$%^&*()_\-+=[{\]};:<>|./?]{8,}$/.test(
      newPassword
    );
  }

  return (
    <>
      {user.loading ? (
        <div className="flex flex-col opacity-70 gap-4">
          <Progress indeterminate />
          <p className="text-center text-xs">
            Please wait while we change your password...
          </p>
        </div>
      ) : null}
      <form className="flex flex-col gap-2 py-2 px-1" onSubmit={onSubmit}>
        <PasswordField
          disabled={user.loading}
          label="Current Password"
          name="currentPassword"
          onChange={onChange}
          value={values.currentPassword}
        />
        <PasswordField
          error={newPasswordError}
          errorHelper="New password does not meet requirements listed below"
          disabled={user.loading}
          label="New Password"
          name="newPassword"
          onChange={onChange}
          value={values.newPassword}
        />
        <PasswordField
          error={confirmError}
          errorHelper="Confirm password does not match new password"
          disabled={user.loading}
          label="Confirm New Password"
          name="newConfirm"
          onChange={onChange}
          value={values.newConfirm}
        />
        <PasswordRequirements error={newPasswordError} />
        <PasswordFormButtons
          error={newPasswordError || confirmError}
          loading={user && user.loading}
          onClose={onClose}
          formValues={values}
        />
      </form>
    </>
  );
};
